import { Component, Input } from '@angular/core';
import {
	AufgabenTyp,
	AufgabeResource,
	AufgabeZertifikatsauszugBody,
	AufgabeZertifikatTaetigkeitLabel,
} from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-zertifikatsauszug-body',
	templateUrl: './aufgabe-zertifikatsauszug-body.component.html',
	styleUrls: ['./aufgabe-zertifikatsauszug-body.component.scss'],
	standalone: false,
})
export class AufgabeZertifikatsauszugBodyComponent {
	@Input() aufgabe: AufgabeResource;

	readonly zertifikatTaetigkeitLabel = AufgabeZertifikatTaetigkeitLabel;
	readonly aufgabenTyp = AufgabenTyp;

	get body(): AufgabeZertifikatsauszugBody {
		return <AufgabeZertifikatsauszugBody>this.aufgabe.body;
	}
}
